import i18n, { InitOptions } from 'i18next';

import * as ES from 'locales/es';
import * as EN from 'locales/en';
// Kebab-case namespace (`auto-adjustment-rules`) cannot be re-exported through
// the `locales/{es,en}/index.ts` barrels because TS target=es2015 rejects the
// `export { default as 'auto-adjustment-rules' }` syntax. Imported directly
// here and merged into `resources` via a computed property until namespaces
// get a normalized camelCase alias convention.
import autoAdjustmentRulesES from 'locales/es/auto-adjustment-rules.json';
import autoAdjustmentRulesEN from 'locales/en/auto-adjustment-rules.json';

// the translations
const resources = {
  es: { ...ES, 'auto-adjustment-rules': autoAdjustmentRulesES },
  en: { ...EN, 'auto-adjustment-rules': autoAdjustmentRulesEN },
};

let lng = localStorage.getItem('i18nextLng');
if (!lng) {
  lng = 'es';
  localStorage.setItem('i18nextLng', lng);
}

const options: InitOptions = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  debug: process.env.NODE_ENV !== 'production',
  lng,
  resources,

  fallbackLng: lng,

  ns: ['common'],

  defaultNS: 'common',

  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
};

i18n.on('languageChanged', function (lng) {
  localStorage.setItem('i18nextLng', lng);
  document.documentElement.lang = lng; // html change language
});

if (!i18n.isInitialized) {
  i18n.init(options).then();
}

export default i18n;
